import { useQuery } from '@tanstack/react-query'

import { fetchLeadSlaThresholdsMs } from '@/api/system_config'
import { LEAD_OVERDUE_THRESHOLDS_MS } from '@/utils/format'

/**
 * Пороги SLA таймера лидов (мс по статусу) из system_config, кешируются
 * react-query и дедуплицируются между всеми карточками канбана. Пока данные
 * не загрузились / при ошибке — дефолты из format.ts.
 */
export function useLeadSla(): Record<string, number> {
  const { data } = useQuery({
    queryKey: ['lead-sla'],
    queryFn: fetchLeadSlaThresholdsMs,
    staleTime: 5 * 60 * 1000,
  })
  return data ?? LEAD_OVERDUE_THRESHOLDS_MS
}
